<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import DetailsImport from './DetailsImport/index.vue';
	import InvoiceToUpdate from './InvoiceToUpdate/index.vue';
	import InvoiceToSee from './InvoiceToSee/index.vue';
	import comMapping from '../../../../comMapping';
	import configHttp from '../../../../../configHttp';
	import Authentication from '@/components/page/FullyElectronicInvoices/FillingPositiveInvoice/Authentication';
	export default {
		components: {
			DetailsImport,
			InvoiceToUpdate,
			InvoiceToSee,
			Authentication
		},
		data() {
			return {
				//授信额度
				findLineCredit: {
					unusedQuotaHasBeenDownloaded: "0.00",
				},
				itemVlue: '',
				projectName: '',
				comMapping: comMapping,
				//表格筛选
				shaidiag: false,
				headData: JSON.parse(localStorage.getItem(
					'../components/page/AllelectricInvoice/FillingPositiveInvoice')) || getdata().headData,
				//headData: getdata().headData,
				outlist: JSON.parse(localStorage.getItem(
					'../components/page/AllelectricInvoice/FillingPositiveInvoice')) || [],
				//表格搜索
				searchlist: getdata().searchlist,
				searchdata: getdata().searchdata,
				//表格
				tableHeight: null,
				tableData: [{}],
				pagination: getdata().pagination,
				tablekey: 0,
				activeName: '026',
				value1: '',
				Preview: false,
				importtk: false,
				entering: false,
				//销方信息
				ruleFormbxiao: {
					name: '', //销售方名称
					taxNumber: '', //销售方名称纳税人识别号
					addressPhone: '', //销售方名称地 址、电 话
					bankAccount: '', //销售方名称开户行及账号
					bpayee: '', //收款人
					breview: '', //复 核
					bdrawer: '' //开票人
				},
				//购方信息
				ruleFormb: {
					customerNumber: '', //客户编号
					customerName: '', //购买方名称
					taxIdentificationNumber: '', //购买方纳税人识别号
					shoupfzrrbs: false, //是否开票给自然人
					address: '', //购买方地 址、电 话
					bank: '' //购买方开户行及账号
				},
				//状态
				stateall: {
					istaxincluded: false, //是否含税
					choosetitleindex: '' //发票类型 新增也要传
				},
				//票据明细
				priceall: [{}, {}, {}, {}, {}, {}, {}, {}],
				//附加信息
				srk: [],
				//经办人信息
				jbrdata: {
					xingm: '',
					guoj: '',
					zhengjlx: '',
					bank: '',
					qiybh: ''
				},
				//特定业务
				tdywxz: '',
				//差额征税 减按征税
				cezsxz: '',
				jazsxz: '',
				//特定业务类型
				tedxx: {
					qiybh: '',
					jianzfwfsd: '',
					fasdxxdz: '',
					jianzxmmc: '',
					tudzzsxmbh: '',
					budcdz: '',
					budcxxdz: '',
					zulqqzulqz: ['', ''],
					kuadsbz: '',
					budcqzhm: '',
					mianjdw: ''
				},
				id: '',
				title: '',
				//单据号
				danjh: '',
				//合计
				totalall: {},
				//备注
				bztext: '',
				//收款人
				shoukr: '',
				//复核人
				fuhr: '',
				//开票人
				kaipr: '',
				//排序字段名称
				order: '',
				//排序顺序
				sort: '',
				Anewtk: false, //唤醒重选发票类型弹框
				fpzloptions: getdata().fpzloptions,
				fplxoptions: getdata().fplxoptions,
				tdywoptions: getdata().tdywoptions,
				cezsoptions: getdata().cezsoptions,
				jazsoptions: getdata().jazsoptions,
				fpzl: '',
				fplx: '',
				cxtdywxz: '',
				cxcezsxz: '',
				cxjazsxz: '',
				isjytdyw: false,
				isjycezs: false,
				isjyjazs: false,
				daorudiag: false,



				authenticationDialogShowFlag: false,
				smsOrQrCode: "sms",
				qrCode: "",
				refreshDate : "",
				kpr : "",
			};
		},
		created() {
			this.getCurrProject();
		},
		mounted() {
			this.DataQuery();
		},
		watch: {
			fpzl: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			cxtdywxz: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			cxcezsxz: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			cxjazsxz: function(indexVal, oldVal) {
				this.ChangeInMonitoring();
			},
			activeName: function(indexVal, oldVal) {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.DataQuery();
			},
			value1: function(indexVal, oldVal) {
				let patea = {
					automaticAudit: indexVal == true ? 1 : 0,
					faplxdm: this.activeName
				};
				this.$https.fetchPost('felec/positiveInvoice/updateIsAutomaticAudit', patea).then(res => {
					if (res.data.code == '200') {}
				});
			}
		},
		methods: {
			closeAuthenticationDialog() {
				this.authenticationDialogShowFlag = false;
			},
			reelecttype() {
				if (this.fpzl == "") {
					this.$message.error("请选择发票种类");
					return;
				}
				if (this.fplx == "") {
					this.$message.error("请选择发票类型");
					return;
				}
				let params = {};
				params.ids = this.$refs.tablebox.getSelectionval().map(v => v.id);
				params.chaezs = this.cxcezsxz;
				params.faplxdm = this.fplx;
				params.fapzl = this.fpzl;
				params.jianazs = this.cxjazsxz;
				params.tedywlx = this.cxtdywxz;
				console.log(params)
				this.$https.fetchPost('/felec/positiveInvoice/docConversion', params).then(res => {
					if (res.data.code == '200') {
						this.$message.success("共改变" + res.data.data.totalNumber + "张发票，成功" + res.data.data
							.successNumber + "条，失败" + res.data.data.failNumber + "条");

					} else {
						this.$message.error(res.data.message);
					}
					this.Anewtk = false;
					this.DataQuery();
				});
			},
			ChangeInMonitoring() {
				if (this.fpzl == '1') {
					this.isjytdyw = true;
					this.isjycezs = true;
					this.isjyjazs = true;
					this.cxtdywxz = '';
					this.cxcezsxz = '';
					this.cxjazsxz = '';
				} else {
					if (this.isjytdyw && this.isjycezs && this.isjyjazs) {
						this.isjytdyw = false;
						this.isjycezs = false;
						this.isjyjazs = false;
					}
				}
				if (this.cxtdywxz == '03') {
					this.isjyjazs = true;
					this.cxjazsxz = '';
				} else if (this.cxtdywxz == '06') {
					this.jazsoptions = [{
						value: '2',
						label: '住房租赁'
					}];
					if (this.cxjazsxz != '') {
						this.cxjazsxz = '2';
					}
				} else {
					this.jazsoptions = getdata().jazsoptions;
					if (this.fpzl != '1') {
						this.isjyjazs = false;
					}
				}
				if (this.cxcezsxz != "") {
					this.isjyjazs = true;
					this.cxjazsxz = "";
				} else {
					if (this.fpzl != '1' && this.cxtdywxz != '03') {
						this.isjyjazs = false;
					}
				}

				if (this.cxjazsxz != "") {
					this.isjycezs = true;
					this.cxcezsxz = "";
				} else {
					if (this.fpzl != '1') {
						this.isjycezs = false;
					}
				}


			},
			Anew() {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择需要修改类型的数据');
				} else {
					for (var i = 0; i < this.$refs.tablebox.getSelectionval().length; i++) {
						if (this.$refs.tablebox.getSelectionval()[i].fapzt != '-1' && this.$refs.tablebox
							.getSelectionval()[i].fapzt != '0' && this.$refs.tablebox.getSelectionval()[i].fapzt != '1') {
							this.$message.error("请选择单据状态为[草稿][待审核][已审核]的单据");
							return;
						}
					}
					this.fpzl = ''
					this.fplx = ''
					this.cxtdywxz = ''
					this.cxcezsxz = ''
					this.cxjazsxz = ''
					this.Anewtk = true;
				}

			},
			//获取当前项目
			getCurrProject() {
				let params = {};
				this.$https.fetchPost('rule/getCurrProject', params).then(res => {
					this.projectName = res.data.data;
				});
			},
			//上传txt
			importTxt() {
				this.$upload({
					uploadurl: configHttp.baseURL + 'hip/Invoice/export/txt',
					uploadtitle: '选择文件',
					params: {
						token: localStorage.getItem('token'),
						faplx: this.activeName
					}
				}).then(res => {
					if (res != 'cancel') {
						if (res.code == '200') {
							this.$message.success('导入成功');
						} else {
							this.$message.error('导入失败：' + res.message);
						}
					}
				});
			},
			uploadFile(obj) {

			},
			//排序
			sortchange(e) {
				console.log(e);
				this.order = e.prop;
				if (e.order == 'ascending') {
					this.sort = 'ASC';
				} else if (e.order == 'descending') {
					this.sort = 'DESC';
				} else {
					this.sort = '';
				}
				this.DataQuery();
			},
			//预览
			previewtk(id) {
				let params = id;
				this.$https.fetchPost('felec/positiveInvoice/getDocInformById', params).then(res => {
					if (res.data.code == '200') {
						//发票明细
						this.priceall = [];
						for (var i = 0; i < res.data.data.detailVos.length; i++) {
							if (res.data.data.detailVos[i].faphxz == '1') {
								this.priceall.push({
									taxCode: res.data.data.detailVos[i].shuisbm,
									goodsName: res.data.data.detailVos[i].shangpmc,
									chooseMoney: res.data.data.detailVos[i].jine,
									taxRate: res.data.data.detailVos[i].shuil,
									taxRatemoney: res.data.data.detailVos[i].shuie,
									itemNo: res.data.data.detailVos[i].hangh,
									type: 1,
                                    lingslbz: res.data.data.detailVos[i].lingslbz
								});
							} else {
								this.stateall.istaxincluded = res.data.data.detailVos[i].hansbz == 1 ? true :
									false;
								this.priceall.push({
									unitPrice: res.data.data.detailVos[i].danj,
									unit: res.data.data.detailVos[i].danw,
									spec: res.data.data.detailVos[i].guigxh,
									itemNo: res.data.data.detailVos[i].hangh,
									chooseMoney: res.data.data.detailVos[i].jine,
									taxCode: res.data.data.detailVos[i].shuisbm,
									goodsName: res.data.data.detailVos[i].shangpmc,
									quantity: res.data.data.detailVos[i].shangpsl,
									taxRatemoney: res.data.data.detailVos[i].shuie,
									taxRate: res.data.data.detailVos[i].shuil,
									type: res.data.data.detailVos[i].faphxz,
                                    lingslbz: res.data.data.detailVos[i].lingslbz
								});
							}
						}
						//开票人
						this.kaipr = res.data.data.doc.kaipr;
						//备注
						this.bztext = res.data.data.doc.beiz;
						//发票类型代码
						this.stateall.choosetitleindex = this.activeName;
						this.stateall.faphm = res.data.data.doc.faphm;
						this.stateall.kaiprq = res.data.data.doc.kaiprq;
						//购方信息
						this.ruleFormb.address = res.data.data.doc.goufdzdh;
						this.ruleFormb.customerName = res.data.data.doc.goufmc;
						this.ruleFormb.customerNumber = res.data.data.doc.customerNo;
						this.ruleFormb.taxIdentificationNumber = res.data.data.doc.goufsbh;
						this.ruleFormb.bank = res.data.data.doc.goufyhzh;
						this.ruleFormb.shoupfzrrbs = res.data.data.doc.shoupfzrrbs == '0' ? false : true;
						//销方
						this.ruleFormbxiao.addressPhone = res.data.data.doc.xiaofdzdh;
						this.ruleFormbxiao.name = res.data.data.doc.xiaofmc;
						this.ruleFormbxiao.taxNumber = res.data.data.doc.xiaofsbh;
						this.ruleFormbxiao.bankAccount = res.data.data.doc.xiaofyhzh;
						//经办人信息
						this.jbrdata.xingm = res.data.data.doc.goufjbrxm;
						this.jbrdata.zhengjhm = res.data.data.doc.goumfjbrzjhm;
						this.jbrdata.zhengjlx = res.data.data.doc.goumfjbrzjlx;
						this.jbrdata.guoj = res.data.data.doc.jinbrgj;
						this.jbrdata.qiybh = res.data.data.doc.jinbrzrrnsrsbh;
						//单据号
						this.danjh = res.data.data.doc.danjh;
						//特定业务
						this.tdywxz = res.data.data.doc.tedywlx == null ? '' : res.data.data.doc.tedywlx;
						//差额征税 减按征税
						this.cezsxz = res.data.data.doc.chaezslx == null ? '' : res.data.data.doc.chaezslx;
						this.jazsxz = res.data.data.doc.jianazs == null ? '' : res.data.data.doc.jianazs;
						//合计
						this.totalall.pricetotal = res.data.data.doc.hejje;
						this.totalall.taxtotal = res.data.data.doc.hejse;
						this.totalall.jiastotal = res.data.data.doc.jiashj;
						this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
						console.log(this.totalall);
						//特定业务类型
						if (res.data.data.specificBusinessData != null) {
							this.tedxx = res.data.data.specificBusinessData;
							this.tedxx.zulqqzulqz = ['', ''];
							this.tedxx.zulqqzulqz[0] = res.data.data.specificBusinessData.zulqq;
							this.tedxx.zulqqzulqz[1] = res.data.data.specificBusinessData.zulqz;
						}
						//附加内容
						this.srk = [];
						for (var i = 0; i < res.data.data.additionalElementsVos.length; i++) {
							this.srk.push({
								fujxxmc: res.data.data.additionalElementsVos[i].fujysmc,
								deit: res.data.data.additionalElementsVos[i].fujysnr,
								shujlx: res.data.data.additionalElementsVos[i].shujlx,
								id: res.data.data.additionalElementsVos[i].id
							});
						}
						if (this.activeName == '026') {
							this.title = '电子发票(普通发票)';
						} else if (this.activeName == '028') {
							this.title = '电子发票（增值税专用发票）';
						} else if (this.activeName == '007') {
							this.title = '纸质发票(普通发票)';
						} else if (this.activeName == '004') {
							this.title = '纸质发票(专票填开)';
						}
						this.id = id;
						this.Preview = true;
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//删除
			delline() {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择需要删除的数据');
				} else {
					this.$showConfirm({
						message: '确认删除吗?'
					}).then(res => {
						if (res == 'confirm') {
							for (var i = 0; i < this.$refs.tablebox.getSelectionval().length; i++) {
								if (
									this.$refs.tablebox.getSelectionval()[i].fapzt != '-1' &&
									this.$refs.tablebox.getSelectionval()[i].fapzt != '0' &&
									this.$refs.tablebox.getSelectionval()[i].fapzt != '' &&
									this.$refs.tablebox.getSelectionval()[i].fapzt != null
								) {
									this.$message.error('只允许删除草稿和待审核状态的单据');
									return;
								}
							}

							let patea = this.$refs.tablebox
								.getSelectionval()
								.map(v => v.id)
								.join(',');
							this.$https.fetchPost('felec/positiveInvoice/delDoc', patea).then(res => {
								if (res.data.code == '200') {
									this.pagination.pageNum = 1;
									this.pagination.paginationkey++;
									this.DataQuery();
								} else {
									this.$message.error(res.data.message);
								}
							});
						}
					});
				}
			},
			//设置为待审核
			ToAudit() {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择需要设为待审核的数据');
				} else {
					this.$showConfirm({
						message: '确认设为待审核吗?'
					}).then(res => {
						if (res == 'confirm') {
							let patea = this.$refs.tablebox
								.getSelectionval()
								.map(v => v.id)
								.join(',');
							this.$https.fetchPost('felec/positiveInvoice/cancelAudit', patea).then(res => {
								if (res.data.code == '200') {
									this.pagination.pageNum = 1;
									this.pagination.paginationkey++;
									this.DataQuery();
								} else {
									this.$message.error(res.data.message);
								}
							});
						}
					});
				}
			},
			//审核
			audit() {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择需要审核的数据');
				} else {
					this.$showConfirm({
						message: '确认进行审核吗?'
					}).then(res => {
						if (res == 'confirm') {
							let patea = this.$refs.tablebox
								.getSelectionval()
								.map(v => v.id)
								.join(',');
							this.$https.fetchPost('felec/positiveInvoice/audit', patea).then(res => {
								if (res.data.code == '200') {
									this.$message.success(res.data.message);
									this.pagination.pageNum = 1;
									this.pagination.paginationkey++;
									this.DataQuery();
								} else {
									this.$message.error(res.data.message);
								}
							});
						}
					});
				}
			},
			//拆分合并
			handleCommand(command) {
				if (command == 'insertcf') {
					if (this.$refs.tablebox.getSelectionval().length == 0 || this.$refs.tablebox.getSelectionval().length >
						1) {
						if (this.$refs.tablebox.getSelectionval().length == 0) {
							this.$message.error('请选择要拆分的数据');
						}
						if (this.$refs.tablebox.getSelectionval().length > 1) {
							this.$message.error('只能拆分一条数据');
						}
					} else {
						this.$showConfirm({
							message: '确认拆分吗?'
						}).then(res => {
							if (res == 'confirm') {}
						});
					}
				} else if (command == 'inserthb') {
					if (this.$refs.tablebox.getSelectionval().length < 2) {
						this.$message.error('请选择两条或两条以上的数据');
					} else {
						this.$showConfirm({
							message: '确认合并吗?'
						}).then(res => {
							if (res == 'confirm') {
								let patea = this.$refs.tablebox
									.getSelectionval()
									.map(v => v.id)
									.join(',');
								this.$https.fetchPost('felec/positiveInvoice/mergeSameCustomer', patea).then(
									res => {
										if (res.data.code == '200') {
											this.$message.success(res.data.message);
											this.pagination.pageNum = 1;
											this.pagination.paginationkey++;
											this.DataQuery();
										} else {
											this.$message.error(res.data.message);
										}
									});
							}
						});
					}
				}
			},
			//录入保存
			InvoiceBackInformation(v) {
				//附加内容
				let additionalElementsVos = [];
				for (var i = 0; i < v.srk.length; i++) {
					additionalElementsVos.push({
						fujysmc: v.srk[i].fujxxmc,
						fujysnr: v.srk[i].deit,
						shujlx: v.srk[i].shujlx,
						id: v.srk[i].id
					});
				}
				//发票头信息
				let doc = {};
				//备注
				doc.beiz = v.bztext;
				//发票类型
				doc.faplxdm = v.stateall.choosetitleindex;
				//含税标志
				doc.hansbz = v.stateall.istaxincluded == true ? 1 : 0;
				//购方
				doc.goufdzdh = v.ruleFormb.address;
				doc.customerNo = v.ruleFormb.customerNumber;
				doc.goufmc = v.ruleFormb.customerName;
				doc.goufsbh = v.ruleFormb.taxIdentificationNumber;
				doc.goufyhzh = v.ruleFormb.bank;
				doc.shoupfzrrbs = v.ruleFormb.shoupfzrrbs == true ? '1' : '0';
				//销方No
				doc.xiaofdzdh = v.ruleFormbxiao.addressPhone;
				doc.xiaofmc = v.ruleFormbxiao.name;
				doc.xiaofsbh = v.ruleFormbxiao.taxNumber;
				doc.xiaofyhzh = v.ruleFormbxiao.bankAccount;
				//特定业务类型
				doc.tedywlx = v.tdywxz;
				//经办人信息
				doc.goufjbrxm = v.jbrdata.xingm;
				doc.goumfjbrzjhm = v.jbrdata.zhengjhm;
				doc.goumfjbrzjlx = v.jbrdata.zhengjlx;
				doc.jinbrgj = v.jbrdata.guoj;
				doc.jinbrzrrnsrsbh = v.jbrdata.qiybh;
				//合计
				doc.hejje = v.totalall.pricetotal;
				doc.hejse = v.totalall.taxtotal;
				doc.jiashj = v.totalall.jiastotal;
				//开票人
				doc.kaipr = v.kaipr;
				//含税税率标识
				if (v.cezsxz != '') {
					doc.hansslbs = '2';
					doc.chaezslx = v.cezsxz;
				} else if (v.jazsxz != '') {
					doc.hansslbs = '1';
					doc.jianazs = v.jazsxz;
				} else {
					doc.hansslbs = '0';
				}
				doc.id = v.id;
				doc.danjh = v.danjh;
				//复核人
				doc.fuhr = v.doc.fuhr
				doc.shoukr = v.doc.shoukr
				//发票明细信息
				let detailVos = [];
				for (var i = 0; i < v.priceall.length; i++) {
					if (v.priceall[i].type == '1') {
						detailVos.push({
							cank0: v.priceall[i].cank0,
							cank1: v.priceall[i].cank1,
							cank2: v.priceall[i].cank2,
							cank3: v.priceall[i].cank3,
							cank4: v.priceall[i].cank4,
							cank5: v.priceall[i].cank5,
							cank6: v.priceall[i].cank6,
							cank7: v.priceall[i].cank7,
							cank8: v.priceall[i].cank8,
							cank9: v.priceall[i].cank9,
							createTime: v.priceall[i].createTime,
							danjh: v.priceall[i].danjh,
							fapdm: v.priceall[i].fapdm,
							faphm: v.priceall[i].faphm,
							id: v.priceall[i].id,
							lingslbz: v.priceall[i].lingslbz,
							rowNum: v.priceall[i].rowNum,
							shangpbm: v.priceall[i].shangpbm,
							updateTime: v.priceall[i].updateTime,
							version: v.priceall[i].version,
							youhzcbz: v.priceall[i].youhzcbz,
							youhzcsm: v.priceall[i].youhzcsm,
							shuisbm: v.priceall[i].taxCode,
							shangpmc: v.priceall[i].goodsName,
							zhekje: 0,
							zhekl: null,
							zhekse: 0,
							hangh: v.priceall[i].itemNo,
							jine: v.priceall[i].chooseMoney,
							faphxz: v.priceall[i].type,
							shuil: v.priceall[i].taxRate,
							shuie: v.priceall[i].taxRatemoney,
							danj: v.priceall[i].unitPrice,
							danw: v.priceall[i].unit,
							guigxh: v.priceall[i].spec,
							shangpsl: v.priceall[i].quantity,
							hansbz: v.stateall.istaxincluded == true ? 1 : 0
						});
					} else {
						detailVos.push({
							cank0: v.priceall[i].cank0,
							cank1: v.priceall[i].cank1,
							cank2: v.priceall[i].cank2,
							cank3: v.priceall[i].cank3,
							cank4: v.priceall[i].cank4,
							cank5: v.priceall[i].cank5,
							cank6: v.priceall[i].cank6,
							cank7: v.priceall[i].cank7,
							cank8: v.priceall[i].cank8,
							cank9: v.priceall[i].cank9,
							createTime: v.priceall[i].createTime,
							danjh: v.priceall[i].danjh,
							fapdm: v.priceall[i].fapdm,
							faphm: v.priceall[i].faphm,
							id: v.priceall[i].id,
							lingslbz: v.priceall[i].lingslbz,
							rowNum: v.priceall[i].rowNum,
							shangpbm: v.priceall[i].shangpbm,
							updateTime: v.priceall[i].updateTime,
							version: v.priceall[i].version,
							youhzcbz: v.priceall[i].youhzcbz,
							youhzcsm: v.priceall[i].youhzcsm,
							zhekje: 0,
							zhekl: null,
							zhekse: 0,
							danj: v.priceall[i].unitPrice,
							danw: v.priceall[i].unit,
							guigxh: v.priceall[i].spec,
							hangh: v.priceall[i].itemNo,
							jine: v.priceall[i].chooseMoney,
							shuisbm: v.priceall[i].taxCode,
							shangpmc: v.priceall[i].goodsName,
							shangpsl: v.priceall[i].quantity,
							shuie: v.priceall[i].taxRatemoney,
							hansbz: v.stateall.istaxincluded == true ? 1 : 0,
							shuil: v.priceall[i].taxRate,
							faphxz: v.priceall[i].type
						});
					}
				}
				//特定业务类型
				let specificBusinessData = v.tedxx;
				if (v.tedxx.zulqqzulqz.length > 1) {
					// specificBusinessData.zulqq = this.rTime(v.tedxx.zulqqzulqz[0]);
					// specificBusinessData.zulqz = this.rTime(v.tedxx.zulqqzulqz[1]);
					specificBusinessData.zulqq = v.tedxx.zulqqzulqz[0];
					specificBusinessData.zulqz = v.tedxx.zulqqzulqz[1];
				}
				let params = {
					additionalElementsVos: additionalElementsVos,
					doc: doc,
					detailVos: detailVos,
					specificBusinessData: specificBusinessData
				};

				this.$https.fetchPost('felec/positiveInvoice/saveOrUpdateDoc', params).then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.message);
						this.pagination.pageNum = 1;
						this.pagination.paginationkey++;
						this.DataQuery();
						this.entering = false;
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//编辑
			compiletk(id, item) {
				let params = id;
				this.$https.fetchPost('felec/positiveInvoice/getDocInformById', params).then(res => {
					if (res.data.code == '200') {
						//发票明细
						this.priceall = [];
						for (var i = 0; i < res.data.data.detailVos.length; i++) {
							if (res.data.data.detailVos[i].faphxz == '1') {
								this.priceall.push({
									cank0: res.data.data.detailVos[i].cank0,
									cank1: res.data.data.detailVos[i].cank1,
									cank2: res.data.data.detailVos[i].cank2,
									cank3: res.data.data.detailVos[i].cank3,
									cank4: res.data.data.detailVos[i].cank4,
									cank5: res.data.data.detailVos[i].cank5,
									cank6: res.data.data.detailVos[i].cank6,
									cank7: res.data.data.detailVos[i].cank7,
									cank8: res.data.data.detailVos[i].cank8,
									cank9: res.data.data.detailVos[i].cank9,
									createTime: res.data.data.detailVos[i].createTime,
									danjh: res.data.data.detailVos[i].danjh,
									fapdm: res.data.data.detailVos[i].fapdm,
									faphm: res.data.data.detailVos[i].faphm,
									id: res.data.data.detailVos[i].id,
									lingslbz: res.data.data.detailVos[i].lingslbz,
									rowNum: res.data.data.detailVos[i].rowNum,
									shangpbm: res.data.data.detailVos[i].shangpbm,
									updateTime: res.data.data.detailVos[i].updateTime,
									version: res.data.data.detailVos[i].version,
									youhzcbz: res.data.data.detailVos[i].youhzcbz,
									youhzcsm: res.data.data.detailVos[i].youhzcsm,
									zhekje: 0,
									zhekl: null,
									zhekse: 0,
									taxCode: res.data.data.detailVos[i].shuisbm,
									goodsName: res.data.data.detailVos[i].shangpmc,
									chooseMoney: res.data.data.detailVos[i].jine,
									taxRate: res.data.data.detailVos[i].shuil,
									taxRatemoney: res.data.data.detailVos[i].shuie,
									itemNo: res.data.data.detailVos[i].hangh,
									unitPrice: res.data.data.detailVos[i].danj,
									unit: res.data.data.detailVos[i].danw,
									spec: res.data.data.detailVos[i].guigxh,
									quantity: res.data.data.detailVos[i].shangpsl,
									hansbz: res.data.data.detailVos[i].hansbz == 1 ? true : false,
									type: 1
								});
							} else {
								this.stateall.istaxincluded = res.data.data.detailVos[i].hansbz == 1 ? true :
									false;
								this.priceall.push({
									cank0: res.data.data.detailVos[i].cank0,
									cank1: res.data.data.detailVos[i].cank1,
									cank2: res.data.data.detailVos[i].cank2,
									cank3: res.data.data.detailVos[i].cank3,
									cank4: res.data.data.detailVos[i].cank4,
									cank5: res.data.data.detailVos[i].cank5,
									cank6: res.data.data.detailVos[i].cank6,
									cank7: res.data.data.detailVos[i].cank7,
									cank8: res.data.data.detailVos[i].cank8,
									cank9: res.data.data.detailVos[i].cank9,
									createTime: res.data.data.detailVos[i].createTime,
									danjh: res.data.data.detailVos[i].danjh,
									fapdm: res.data.data.detailVos[i].fapdm,
									faphm: res.data.data.detailVos[i].faphm,
									id: res.data.data.detailVos[i].id,
									lingslbz: res.data.data.detailVos[i].lingslbz,
									rowNum: res.data.data.detailVos[i].rowNum,
									shangpbm: res.data.data.detailVos[i].shangpbm,
									updateTime: res.data.data.detailVos[i].updateTime,
									version: res.data.data.detailVos[i].version,
									youhzcbz: res.data.data.detailVos[i].youhzcbz,
									youhzcsm: res.data.data.detailVos[i].youhzcsm,
									zhekje: 0,
									zhekl: null,
									zhekse: 0,
									hansbz: res.data.data.detailVos[i].hansbz == 1 ? true : false,
									unitPrice: res.data.data.detailVos[i].danj,
									unit: res.data.data.detailVos[i].danw,
									spec: res.data.data.detailVos[i].guigxh,
									itemNo: res.data.data.detailVos[i].hangh,
									chooseMoney: res.data.data.detailVos[i].jine,
									taxCode: res.data.data.detailVos[i].shuisbm,
									goodsName: res.data.data.detailVos[i].shangpmc,
									quantity: res.data.data.detailVos[i].shangpsl,
									taxRatemoney: res.data.data.detailVos[i].shuie,
									taxRate: res.data.data.detailVos[i].shuil,
									type: res.data.data.detailVos[i].faphxz
								});
							}
						}
						//开票人
						this.kaipr = res.data.data.doc.kaipr;
						//发票类型代码
						this.stateall.choosetitleindex = this.activeName;
						this.stateall.faphm = res.data.data.doc.faphm;
						this.stateall.kaiprq = res.data.data.doc.kaiprq;
						//备注
						this.bztext = res.data.data.doc.beiz;
						this.fuhr = res.data.data.doc.fuhr;
						this.shoukr = res.data.data.doc.shoukr;
						//购方信息
						this.ruleFormb.address = res.data.data.doc.goufdzdh;
						this.ruleFormb.customerName = res.data.data.doc.goufmc;
						this.ruleFormb.customerNumber = res.data.data.doc.customerNo;
						this.ruleFormb.taxIdentificationNumber = res.data.data.doc.goufsbh;
						this.ruleFormb.bank = res.data.data.doc.goufyhzh;
						this.ruleFormb.shoupfzrrbs = res.data.data.doc.shoupfzrrbs == '0' ? false : true;
						//销方
						this.ruleFormbxiao.addressPhone = res.data.data.doc.xiaofdzdh;
						this.ruleFormbxiao.name = res.data.data.doc.xiaofmc;
						this.ruleFormbxiao.taxNumber = res.data.data.doc.xiaofsbh;
						this.ruleFormbxiao.bankAccount = res.data.data.doc.xiaofyhzh;
						//经办人信息
						this.jbrdata.xingm = res.data.data.doc.goufjbrxm;
						this.jbrdata.zhengjhm = res.data.data.doc.goumfjbrzjhm;
						this.jbrdata.zhengjlx = res.data.data.doc.goumfjbrzjlx;
						this.jbrdata.guoj = res.data.data.doc.jinbrgj;
						this.jbrdata.qiybh = res.data.data.doc.jinbrzrrnsrsbh;
						//单据号
						this.danjh = res.data.data.doc.danjh;
						//特定业务
						this.tdywxz = res.data.data.doc.tedywlx == null ? '' : res.data.data.doc.tedywlx;
						//差额征税 减按征税
						this.cezsxz = res.data.data.doc.chaezslx == null ? '' : res.data.data.doc.chaezslx;
						this.jazsxz = res.data.data.doc.jianazs == null ? '' : res.data.data.doc.jianazs;
						//合计
						this.totalall.pricetotal = res.data.data.doc.hejje;
						this.totalall.taxtotal = res.data.data.doc.hejse;
						this.totalall.jiastotal = res.data.data.doc.jiashj;
						this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
						//特定业务类型
						if (res.data.data.specificBusinessData != null) {
							this.tedxx = res.data.data.specificBusinessData;
							this.tedxx.zulqqzulqz = ['', ''];
							this.tedxx.zulqqzulqz[0] = res.data.data.specificBusinessData.zulqq;
							this.tedxx.zulqqzulqz[1] = res.data.data.specificBusinessData.zulqz;
						}
						//附加内容
						this.srk = [];
						for (var i = 0; i < res.data.data.additionalElementsVos.length; i++) {
							this.srk.push({
								fujxxmc: res.data.data.additionalElementsVos[i].fujysmc,
								deit: res.data.data.additionalElementsVos[i].fujysnr,
								shujlx: res.data.data.additionalElementsVos[i].shujlx,
								id: res.data.data.additionalElementsVos[i].id,
								version: res.data.data.additionalElementsVos[i].version,
								createTime: res.data.data.additionalElementsVos[i].createTime,
								updateTime: res.data.data.additionalElementsVos[i].updateTime,
								danjh: res.data.data.additionalElementsVos[i].danjh,
								qiybh: res.data.data.additionalElementsVos[i].qiybh,
								fujysmc: res.data.data.additionalElementsVos[i].fujysmc,
								fujysnr: res.data.data.additionalElementsVos[i].fujysnr
							});
						}
						if (this.activeName == '026') {
							this.title = '单据编辑-数电电子普票填开';
						} else if (this.activeName == '028') {
							this.title = '单据编辑-数电电子专票填开';
						} else if (this.activeName == '007') {
							this.title = '单据编辑-数电纸质普票填开';
						} else if (this.activeName == '004') {
							this.title = '单据编辑-数电纸质专票填开';
						}
						this.id = id;
						this.itemVlue = item
						this.entering = true;
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			rTime(date) {
				var time = new Date(date);
				var y = time.getFullYear();
				var m = time.getMonth() + 1;
				var d = time.getDate();
				var h = time.getHours();
				var mm = time.getMinutes();
				var s = time.getSeconds();
				return y + '' + this.add0(m) + '' + this.add0(d);
			},
			add0(m) {
				return m < 10 ? '0' + m : m;
			},
			//单据录入弹框
			enteringtk() {
				let params = {
					faplx: ''
				};
				this.$https.fetchPost('/invoice/issueInfo/getCurRuleFormbxiao', params).then(res => {
					if (res.data.obj.length > 0) {
						this.ruleFormbxiao = res.data.obj[0];
						this.kaipr = res.data.obj[0].bdrawer;
						this.stateall.choosetitleindex = this.activeName;
						this.stateall.istaxincluded = false;
						if (this.activeName == '026') {
							this.title = '单据录入-数电电子普票填开';
						} else if (this.activeName == '028') {
							this.title = '单据录入-数电电子专票填开';
						} else if (this.activeName == '007') {
							this.title = '单据录入-数电纸质普票填开';
						} else if (this.activeName == '004') {
							this.title = '单据录入-数电纸质专票填开';
						}
						this.entering = true;
						this.$refs.iceToSee.relese();
					} else {
						this.$message.error('失败');
					}
				});
			},
            //强制开具
            forceIssue(){
                let list = this.$refs.tablebox.getSelectionval();
                if (list.length == 0) {
                    return this.$message.error('请选择数据！');
                }
                if (list.length > 1) {
                    return this.$message.error('强制开票只能选择一条数据！');
                }
                if (list[0].fapzt != '7') {
                    return this.$message.error('只能对开票失败的发票进行强制开票！')
                }
                let user = localStorage.getItem("useropj");
                let userInfo = JSON.parse(user);
                let qiybhCode = userInfo.currCompany.code;

                this.$https.fetchGet('rpa/forceInvoiceIssue', {id:list[0].id,qiybh:qiybhCode }).then(res => {
                    console.log(res);
                    if (res.data.code == '200') {
                        if (res.data.data != null && res.data.data.returnCode == '2001') {
                            if (res.data.data.returnData.hasOwnProperty("type")) {
                                this.$message.error(res.data.data.returnMsg);
                                if (res.data.data.returnData.type == '1') {
                                    this.authenticationDialogShowFlag = true;
                                    this.smsOrQrCode = "sms"
                                    this.qrCode = "";
                                } else if (res.data.data.returnData.type == '2') {
                                    this.authenticationDialogShowFlag = true;
                                    this.smsOrQrCode = "qr"
                                    this.qrCode = res.data.data.returnData.qrCode;
                                }
                            } else {
                                this.$message.error(res.data.data.returnMsg);
                            }

                        } else {
                            this.$message.success("开具成功");
                        }
                    } else if(res.data.code == '500'){
                        this.$message.error(res.data.message);
                    } else {
                        this.$message.error("开票失败");
                    }
                    this.DataQuery()
                })
            },
			//开具
			Issue() {
				this.authenticationDialogShowFlag = false;
				let list = this.$refs.tablebox.getSelectionval()
				if (list.length == 0) {
					return this.$message.error('请选择您要开具的数据')
				}
				for (let index = 0; index < list.length; index++) {
					if (list[index].fapzt != '1' && list[index].fapzt != '7') {
						return this.$message.error('您选择的数据有其他状态数据，请全部选择已审核数据。')
					}
				}
				let params = new FormData()
				let ids = list.map(item => item.id)
				params.append('ids', ids.join(','))
				this.$https.fetchPost('/felec/positiveInvoice/openInvoice', params).then(res => {
					if (res.data.code == '200') {
						if (res.data.data != null && res.data.data.returnCode == '2001') {
							if (res.data.data.returnData.hasOwnProperty("type")) {
								this.$message.error(res.data.data.returnMsg);
								if (res.data.data.returnData.type == '1') {
									this.authenticationDialogShowFlag = true;
									this.smsOrQrCode = "sms"
									this.qrCode = "";
								} else if (res.data.data.returnData.type == '2') {
									this.authenticationDialogShowFlag = true;
									this.smsOrQrCode = "qr"
									this.qrCode = res.data.data.returnData.qrCode;
								}
							} else {
								this.$message.error(res.data.data.returnMsg);
							}

						} else {
							this.$message.success("开具成功");
						}
					} else {
						this.$message.error("开票失败：" + res.data.message);
					}
					this.DataQuery()
				});


			},
			//数据查询
			DataQuery() {
				//todo 需要加双日判断
				if (configHttp.shuangRiTaxNumber) {
					let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
					let userobj = JSON.parse(localStorage.getItem('useropj'));
					let qiybh = userobj.currCompany.code;
					if (shuangRiTaxNumber.includes(qiybh)) {
						this.searchdata.fapzl = "2";
						this.searchdata.cank1 = "3";
					}
				}

				let patea = {
					limit: this.pagination.pageSize,
					page: this.pagination.pageNum,
					order: this.order,
					sort: this.sort,
					param: JSON.parse(JSON.stringify(this.searchdata))
				};
				patea.param.faplxdm = this.activeName;
				this.$https.fetchPost('felec/positiveInvoice/getDocList', patea).then(res => {
					if (res.data.code == '200') {
						this.pagination.total = res.data.count;
						this.tableData = res.data.data.map(v => {
							if (v.danjrq != null) {
								if (v.danjrq.length == 8) {
									var reg = /^(\d{4})(\d{2})(\d{2})$/;
									v.chuangjrq = v.danjrq.replace(reg, '$1年$2月$3日');
									v.danjrq = v.danjrq.replace(reg, '$1年$2月$3日');
								} else if (v.danjrq.length == 14) {
									var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
									v.chuangjrq = v.danjrq.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
									v.danjrq = v.danjrq.replace(reg, '$1年$2月$3日');
								}
							}

							return v;
						});

						this.$https.fetchPost('felec/positiveInvoice/getIsAutomaticAudit', this.activeName).then(
							res => {
								if (res.data.code == '200') {
									this.value1 = res.data.data.automaticAudit == '0' ? false : true;
								}
							});
							this.$https.fetchPost('/natural/credit/findLineCredit').then(res => {
								if (res.data.code == '200') {
									this.findLineCredit = res.data.data;
								} 
							});
					} else {
						this.$message.error('失败');
					}
				});
			},
			closediag() {
				console.log(1);
				this.importtk = false;
			},
			closediagew() {
				console.log(1);
				this.Preview = false;
			},
			closediaglr() {
				this.entering = false;
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			//表格筛选
			closeshaidiag() {
				this.shaidiag = false;
			},
			confirmfilter(e) {
				localStorage.setItem('../components/page/AllelectricInvoice/FillingPositiveInvoice', JSON.stringify(e
					.nochooselist));
				localStorage.setItem('../components/page/AllelectricInvoice/FillingPositiveInvoice', JSON.stringify(e
					.chooselist));
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
				this.$refs.tablebox.dout();
				this.tablekey++;
			},
			//表格搜索
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.DataQuery();
			},
			//表格分页
			sizechange(e) {
				this.pagination.pageSize = e;
				this.DataQuery();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.DataQuery();
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>
